<style lang="less">@import "../css/login.less";</style>
<template>
    <div class="loginBox">
        <el-button type="primary" @click="test">测 试</el-button>
    </div>
</template>

<script>
import { get_local_desc, get_local_device_p7b } from '@/api/shield'
import { checkShield } from '@/api/user'

export default {
    name: 'dun',
    data() {
        return {
        }
    },
    methods: {
        test(){
            checkShield().then(res=>{
                console.log(res)
                if(res.code === 1){
                    this.$msgs("加密锁验证成功")
                }
            })
            return 
            console.log("aaa")
            get_local_desc().then(res=>{
                console.log(res)
                if(res.code == 0){
                    let local_desc = JSON.parse(res.data);
                    if (local_desc.length === 0) {
                        this.$msg("未发现加密锁")
                        return;
                    }else if (local_desc.length !== 1) {
                        this.$msg("发现多把加密锁，请拔出其中一把后重试")
                        return;
                    }
                    get_local_device_p7b().then(res=>{
                        if(res.code ==0){
                            let detail = JSON.parse(res.data)[0];
                            let shell_num = detail["shell_num"];
                            let lock_sn = detail["lock_sn"];
                            console.log("shell_num:"+shell_num)
                            console.log("lock_sn:"+lock_sn)
                        }else{
                            this.$msg("获取加密锁证书链出错：" + res.code)
                        }
                    })
                }
            })
            .catch(error=>{
                this.$msg("请按照U盾相应服务")
                //console.log(error)
            })
        }
    }
}
</script>